const shop = {
    "LBL_PAGE_TITLE":"Magazin",
    "LBL_TAB_INDIVIDUAL":"Lecții individuale",
    "LBL_TAB_GROUP":"Lecții în grup",
    "LBL_TAB_MASTER_LESSONS":"Lecții cu maestru",
    "BTN_MAKE_ORDER":"Cumpără",
    "LBL_LECTIE_PRICE":"lectie",
    "LBL_DISCOUNT_VALUE":"Economie de",
    "LBL_POPUP_TITLE":"Cont de plată",
    "LBL_POPUP_PRODUCT":"Abonament {count} lecții",
    "LBL_POPUP_DISCOUNT":"Reducere {discount} %",
    "LBL_POPUP_TOTAL":"Total",
    "LBL_POPUP_PAYMENT_METHOD":"Alege metoda de plată",
    "LBL_POPUP_HELPER":"La selectarea metodei de plăți “Card Bancar” veți fi taxat în Lei Moldovenești (MDL).",
    "LBL_PAYMENT_METHOD_CARD":"Card bancar",
    "LBL_PAYMENT_METHOD_PAYPAL":"PayPal",
    "LBL_CART_PAGE_TITLE":"Coș",
    "LBL_PAYMENT_SUCCESS_TITLE":"Plata a fost confirmată",
    "LBL_PAYMENT_SUCCESS_DESCRIPTION":"Vă mulțumim mult pentru cumpărătură!<br/>Managerul Academiei va lua legătura cu în cel mai scurt timp posibil!",
    "LBL_PAYMENT_TRANSACTION_ID":"ID Tranzacție",
    "LBL_PAYMENT_TRANSACTION_DATE":"Data și ora",
    "LBL_PAYMENT_TRANSACTION_TOTAL":"Suma",
    "LBL_PAYMENT_FAILURE_TITLE":"Operațiune nereușită",
    "LBL_PAYMENT_FAILURE_BUTTON":"Încearcă din nou",
    "LBL_ENTER_PROMOCODE":"Introduceți codul promoțional",
    "LBL_LEVEL_1":"Pentru începători",
    "LBL_LEVEL_1_DESCRIPTION":"Regulile de joc, combinațiile elementare debutul, jocul de mijloc, finalurile simple",
    "LBL_LEVEL_2":"Pentru avansați",
    "LBL_LEVEL_2_DESCRIPTION":"Jocul strategic, lupta pentru centru, tipurile de atac și apărare, avantajul pozițional",
    "LBL_LEVEL_3":"Pentru avansați",
    "LBL_LEVEL_3_DESCRIPTION":"Jocul strategic, lupta pentru centru, tipurile de atac și apărare, avantajul pozițional",
};
export default shop